import _ from 'lodash';

export default class ThumbBucketProfileCapacityView {
  constructor(item) {
    if (item) {
      this.minimumCapacity = item.minimumCapacity
        ? Number(item.minimumCapacity).toFixed(2)
        : null;
      this.maximumCapacity = item.maximumCapacity
        ? Number(item.maximumCapacity).toFixed(2)
        : null;
      this.tipRadius = item.tipRadius;

      return;
    }
    this.minimumCapacity = null;
    this.maximumCapacity = null;
    this.tipRadius = 0;
  }

  getBucketForDisplay(capacityUnitsName) {
    const desc = '';

    if (!this.minimumCapacity && !this.maximumCapacity) return desc + 'Any';

    if (!this.minimumCapacity)
      return (
        desc +
        'Up to ' +
        this.maximumCapacity.toString() +
        ' ' +
        capacityUnitsName
      );

    if (!this.maximumCapacity)
      return (
        desc +
        this.minimumCapacity.toString() +
        ' ' +
        capacityUnitsName +
        ' and up'
      );

    return (
      desc +
      this.minimumCapacity.toString() +
      ' ' +
      capacityUnitsName +
      ' to ' +
      this.maximumCapacity.toString() +
      ' ' +
      capacityUnitsName
    );
  }

  clone() {
    return _.cloneDeep(this);
  }
}
